<template>
	<auto-complete
		:value="value"
		@value="newValue => $emit('value', newValue)"
		:items="items"
		:is-required="isRequired"
		color="primary"
		item-text="text"
		item-value="value"
		:label="$t('common.exploration-unit-type')"
		outlined
		clearable
	></auto-complete>
</template>

<script>
import { ExplorationUnitType } from '@/enums';
import AutoComplete from '../default';

export default {
	name: 'ExplorationUnitTypeAutoComplete',
	components: {
		AutoComplete,
	},
	props: {
		value: {},
		isRequired: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		items() {
			return ExplorationUnitType.getAll().map((explorationUnitType) => ({
				text: this.$t(explorationUnitType.title),
				value: explorationUnitType.value,
			}));
		}
	}
};
</script>